<div class="pt-3">
    <div class="grid formgrid">
        <div class="col-6">
            <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="goToList()"></p-button>
        </div>
        <div class="col-6">
            <p-button icon="pi pi-plus-circle" label="New Service" styleClass="p-button-success" class="flex justify-content-center" (onClick)="newServiceModal = true"></p-button>
        </div>
        <div class="col-12 text-center">
            <h3>{{instrument.friendlyInstrumentName}}</h3>
        </div>
    </div>
</div>

<p-table [value]="services" [loading]="loading" [paginator]="true" [rows]="20">
    <ng-template pTemplate="body" let-service>
        <tr>
            <td>
                <div class="grid text-sm">
                    <div class="col-1 font-bold">
                        <i [ngClass]="setInstrumentIconClass(service.outOfService)"></i>
                    </div>
                    <div class="col-11">
                        <div class="formgrid grid">
                            <div class="col-6 font-bold">
                                {{service.subject}}
                            </div>
                            <div class="col-6 text-right text-xs">
                                {{service.dateCreated | date: "EEE, MM/dd/yy hh:mm a"}}
                            </div>
                            <div class="col-12">
                                {{service.tech.fullName}}
                            </div>
                            <div class="col-12 font-medium">
                                {{service.serviceCode.description}}
                            </div>
                            <div class="col-12">
                                <div [innerHTML]="service.description | safe:'html'"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>


<p-dialog header="New Service" [(visible)]="newServiceModal" [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12">
            <label for="serviceCode">Service Code</label>
            <p-dropdown id="serviceCode" [options]="serviceCodes" [(ngModel)]="selectedServiceCode" optionLabel="description" placeholder="Select a service code"></p-dropdown>
        </div>
        <div class="col-12">
            <label for="title">Subject</label>
            <input pInputText id="title" [(ngModel)]="title"/>
        </div>
        <div class="col-12">
            <label for="summary">Description</label>
            <textarea id="summary" rows="5" cols="30" pInputTextarea [(ngModel)]="summary"></textarea>
        </div>
        <div class="col-12 p-1">
            <label for="outOfService">Out of Service</label>
            <p-checkbox id="outOfService" [(ngModel)]="outOfService" [binary]="true" inputId="binary" class="pl-2"></p-checkbox>
        </div>
        <div *ngIf="!outOfService" class="col-12 p-1">
            <label for="resolveGoFMX">Resolve GoFMX</label>
            <p-checkbox id="resolveGoFMX" [(ngModel)]="resolveGoFMX" [binary]="true" inputId="binary" class="pl-2"></p-checkbox>
        </div>
        
        
        <div class="col-6 p-1">
            <p-button label="Cancel" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="newServiceModal = false"></p-button>
        </div>
        <div class="col-6 p-1">
            <p-button icon="pi pi-save" label="Save" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="saveService()"></p-button>
        </div>
    </div>
</p-dialog>
